// Regex trim is better
export function removeWhitespaces(keyString: string): string {
    return  keyString.replace(/\s+/g, '');
}
